export default __webpack_public_path__ + "static/media/FO.27f92db9.svg";